<div [kalLoading]="loading">
    <div kalDialogContent [formGroup]="form">

        <!-- Ajout depuis le PC -->
        <div class="gup-C-flexGroup -row -alignCenter -justifyStart gup-O-list">

            <app-simple-file-upload
                [formControl]="fileUploadControl"
                [extensions]="allowedExtensions"
                id="image_bank_dialog_picture_upload">

                <a id="image_bank_dialog_picture_upload_link"
                   class="gup-C-moreInfos gup-O-link">

                    <kal-icon>
                        <i class="material-icons">add</i>
                    </kal-icon>

                    <span>Ajouter une image depuis mon ordinateur</span>

                </a>
            </app-simple-file-upload>
        </div>

        <div class="gup-C-searchBar">

            <kal-input id="image_bank_dialog_searchbar"
                       icon="search"
                       formControlName="searchbar"
                       class="gup-O-search">
            </kal-input>

            <kal-button id="image_bank_dialog_toggle_filters"
                        class="gup-C-searchBar__filterBtn"
                        kalTheme="large"
                        (click)="toggleFilters()">
                <kal-icon><i class="material-icons">tune</i></kal-icon>
                <span>Filtrer</span>
            </kal-button>

        </div>

        <!-- template pour les filtres d'une liste custom -->
        <ng-template #filtersTemplate>
            <app-image-bank-filters formControlName="tag"></app-image-bank-filters>
        </ng-template>

        <ng-template #listTemplate>

            <cdk-virtual-scroll-viewport itemSize="50">

                <div class="gup-C-imageBank">
                    <div *cdkVirtualFor="let picture of picturesList"
                         (click)="selectImage(picture)"
                         (dblclick)="submitImage(picture)"
                         class="gup-C-imageBank__item" [class.-selected]="picture.IdFile === selectedPicture?.IdFile">

                        <figure class="gup-C-imageBank__imgContainer">

                            <img [alt]="getPictureName(picture)"
                                 [src]="picture.Url">

                        </figure>

                        <div class="gup-C-imageBank__imgFileName xsmall gup-U-color--400">
                            {{ getPictureName(picture) }}
                        </div>

                    </div>

                </div>
            </cdk-virtual-scroll-viewport>

        </ng-template>

        <ng-container *ngTemplateOutlet="isOpenedFilters ? filtersTemplate : listTemplate"></ng-container>

    </div>

    <div kalDialogFooter *ngIf="!isOpenedFilters">

        <div class="gup-C-validationArea gup-O-list">

            <div class="gup-O-list__item">

                <kal-button id="image_bank_dialog_submit"
                            kalTheme="primary"
                            [disabled]="!selectedPicture"
                            (click)="submit()">
                    Ajouter
                </kal-button>

            </div>

            <div class="gup-O-list__item">

                <kal-button id="image_bank_dialog_cancel"
                            kalTheme="secondary"
                            (click)="close()">
                    Annuler
                </kal-button>

            </div>

        </div>

    </div>
</div>
